import React, {Component} from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { LOGIN } from '../../Actions/User'
import { GET_CURRENT_USER } from '../../Actions/User'
import Loader from '../../Components/Loader/Index.js'
import { SET_INBOX } from '../../Actions/Chat'
import { MERCURE_URL } from '../../config'


let logo = require('../../Media/logo.svg');

class Login extends Component {

    state = {
        error: false,
        isLoading: false,
    }

    componentDidMount() {
        // this.refs.submit.click()
    }

    handleLogin = (e) => {
        e.preventDefault();

        this.setState({
            isLoading: true
        })

        this.props.actions.LOGIN(this.refs.username.value, this.refs.password.value)
        .then(() => {
            this.setState({
                isLoading: false
            })

            this.props.actions.SET_INBOX()
            const inboxSource = new EventSource(`${MERCURE_URL}?topic=https://jongenout.nl/inbox/${this.props.user._id}`);
            inboxSource.addEventListener('message', () => {
                this.props.actions.SET_INBOX()
            })

            this.props.actions.GET_CURRENT_USER(this.props.user)


            this.props.history.push('/wazzup')
        })
        .catch((err, test) => {  
            this.setState({
                error: '* Deze inloggegevens zijn onjuist.',
                isLoading: false
            })
        })
    }

    render() {
        const { error, isLoading } = this.state;
        return (
            <div>
                {/* <h1>{user.username}</h1>
                <button onClick={this.handleClick}>Update naam</button> */}
                {
                    isLoading && (
                        <Loader withClass="c-loader--alt" />
                    )
                }
                <div className="c-login-wrapper">
                    <div className="c-form-wrapper">
                        <img className="o-logo" src={logo} alt="Jong en Out logo "/>
                        <form className="c-form" action="" onSubmit={this.handleLogin}>
                            {
                                error && (
                                    <div className="c-form-errors">
                                        {error}
                                    </div>
                                )
                            }
                            
                            <div className="c-form__row">
                                <input className="c-form__input" type="text" name="username" placeholder="E-mailadres"  ref="username" />
                            </div>
                            <div className="c-form__row">
                                <input className="c-form__input" type="password" name="password" placeholder="Wachtwoord"  ref="password" />
                            </div>
                            <button type="submit" className="c-btn c-btn--wide c-btn--centered" ref="submit">Inloggen</button>
                        </form>
                        <a href="/wachtwoord-vergeten/aanvragen" className="help-link">Ik ben mijn wachtwoord vergeten</a>
                        <a href="/registreren" className="help-link">Een account aanmaken</a>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        user: state.user.user
    }
}

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({LOGIN, GET_CURRENT_USER, SET_INBOX}, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)